/*==========================================================
    STICKY HEADER / TUCK & SHOW
==========================================================*/

var lastScrollTop = 0;  // determines last scrolled position
var deltaDown = 0; // determines when the nav shrinks, when scrolling down
var deltaUp = 0; // determines when the nav unshrinks, when scrolling up

$(window).scroll(function () {
    // Detect scroll position
    var st = $(this).scrollTop();

    if (st == lastScrollTop) {
        return;
    } else if (st > lastScrollTop && lastScrollTop >= 0) {
        // If user has scrolled down
        $("html").removeClass("scrollingUp").addClass("scrollingDownward scrolling");
    } else {
        // If user has scrolled up
        $("html").removeClass("scrollingDownward").addClass("scrollingUp scrolling");
    }

    lastScrollTop = st;

    // If user has hit the top of page
    if (st <= deltaUp) {
        $("html").removeClass("scrolling").addClass("hitTop").removeClass("scrollingUp");
    } else {
        $("html").removeClass("hitTop");
    }
});